module.exports = __webpack_public_path__ + "gammausa_logo.png?c8921a2a4ff299625551aeeca4197184";


//////////////////
// WEBPACK FOOTER
// ./src/img/gammausa_logo.png
// module id = 711
// module chunks = 20